import React from 'react';

import Line from './Line.jsx';

export default class MovingLines extends React.Component {

  render() {
    const speeds = this.getLineSpeeds(this.props.type)

    return (
      <div className={`MovingLines ${this.props.type}`}>
        {
          speeds.map((speed, index) => (
            <Line key={index} speed={speed} />
          ))
        }
      </div>
    );
  }

  getLineSpeeds(type) {
    switch(type) {
      case 'above':
        return [0.2, 0.15, 0.3, 0.25];
      case 'below':
        return [0.1, 0.3, 0.25, 0.1];
      default:
    }
  }
};
